import RouterViewSlider from 'src/components/RouterViewSlider';
import { RouteEntityDetail } from 'src/components/EntityDetail';
import { entityDetailRoute } from 'src/components/EntityDetail/entity-route-util';
import { validateWorkOrderSelectAcl, validateWorkOrderUpdateAcl } from './workOrder.validations';
import { createWorkOrder, getEntity, saveEntity } from './workOrder.entity';
import type { Route, RouteConfig } from 'vue-router';
import { accessor } from 'src/store';

export const workOrderRoutes: RouteConfig[] = [
    {
        name: 'work-order-config-nav',
        path: 'work-orders',
        redirect: { name: 'work-order-list' },
        meta: {
            navigationGuard: () => validateWorkOrderSelectAcl(),
            navbarTitle: 'Work Orders',
            navbarIcon: '$argo-work-order',
            transition: 'vertical',
            featureFlags: [ 'unstableWorkOrders' ],
            pageBannerTitle: 'Work Orders',
        },
        component: RouterViewSlider,
        children: [
            {
                name: 'work-orders-nav',
                path: '',
                redirect: { name: 'work-order-list' },
                meta: {
                    navigationGuard: () => validateWorkOrderSelectAcl(),
                    transition: 'horizontal',
                },
                component: RouterViewSlider,
                children: [
                    {
                        name: 'work-order-list',
                        path: 'list',
                        component: () => import(/* webpackChunkName: "work-order" */ './WorkOrderList.view.vue'),
                    },
                    entityDetailRoute<'workOrder'>({
                        name: 'workOrder',
                        path: '/work-order/:workOrderId',
                        component: RouteEntityDetail,
                        redirect: to => ({ name: 'workOrderDetail', params: to.params, query: to.query }),
                        meta: {
                            transition: 'horizontal',
                            entityType: 'workOrder',
                            getEntity,
                            saveEntity,
                            canEdit: () => validateWorkOrderUpdateAcl(),
                            useEntityDetailTabs: false,
                            createEntity: createWorkOrder,
                            pageBannerIcon: '$argo-work-order',
                            returnRoute: { name: 'work-order-list' },
                            routeParamsForFetch: route => ({ workOrderId: route.params.workOrderId }),
                            pageBannerTitle: (route: Route) => {
                                const mode = route.query?.mode || '';
                                const workOrder = accessor.entityAsType('workOrder');
                                if (!workOrder) {
                                    return 'Unknown Work Order';
                                }
                                const workOrderName = workOrder.orderNumber;
                                if (mode === 'create' && !workOrderName) {
                                    return 'New Work Order';
                                }
                                return workOrderName;
                            },
                        },
                        children: [
                            {
                                path: 'create',
                                name: 'workOrderCreate',
                                component: () => import(/* webpackChunkName: "work-order" */ './CreateWorkOrder.vue'),
                            },
                            {
                                path: 'detail',
                                name: 'workOrderDetail',
                                component: () => import(/* webpackChunkName: "work-order" */ './WorkOrderGeneral.view.vue'),
                                meta: {
                                    pageBannerSubtitle: 'Work Order Status Report',
                                    tab: {
                                        label: 'General Settings', // TODO: i81n
                                        icon: 'mdi-cog',
                                    },
                                },
                            },
                        ],
                    }),
                ],
            },
        ],
    },
];
